import request from '@/axios'

export function create_folder (customer_id, query) {
  return request({
    url: `/file/repository/create/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function folder_list (platform_customer_id) {
  return request({
    url: `/file/repository/list/${platform_customer_id}`,
    method: 'GET'
  })
}

export function repoDetails (customer_id, repo_id) {
  return request({
    url: `/file/repository/show/${customer_id}/${repo_id}`,
    method: 'GET'
  })
}

export function repoDelete (customer_id, repository_id) {
  return request({
    url: `/file/repository/delete/${customer_id}/${repository_id}`,
    method: 'GET'
  })
}

export function uploadFile (customer_id, query) {
  return request({
    url: `/file/upload/${customer_id}`,
    method: 'POST',
    data: query
  })
}

// export function addFile (query) {
//   return request({
//     url: '/file/upload/add',
//     method: 'POST',
//     data: query
//   })
// }

export function addFile (query) {
  return request({
    url:'/file/upload/add',
    method:'POST',
    data:query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function fileRename (query) {
  return request({
    url: '/file/rename',
    method: 'POST',
    data: query
  })
}

export function fileDelete (file_id) {
  return request({
    url: `/file/upload/delete/${file_id}`,
    method: 'GET'
  })
}

export function multipleFileDelete (query) {
  return request({
    url: '/file/upload/delete',
    method: 'POST',
    data: query
  })
}

export function statics (id) {
  return request({
    url: `/file/statics/${id}`,
    method: 'GET'
  })
}
